import React, { useState, useEffect } from "react";
import { Link } from "react-router";
import { Menu, Dropdown, Button } from "antd";

import { fetchAuthStatus } from "../ProtectedRoute/ProtectedRoute.jsx"; // Import the auth functions
import { genericDELETEDatabaseCall } from "../helperFunctions.jsx" 

import {
  AppstoreOutlined,
  SolutionOutlined,
  DashboardOutlined,
  DollarOutlined,
  BookOutlined,
  LoginOutlined,
  PhoneOutlined,
  DownOutlined,
  RocketOutlined,
  UpOutlined,
  BarChartOutlined,
  BuildOutlined,
  UsergroupAddOutlined,
  ApartmentOutlined,
  UserOutlined,
  StockOutlined,
} from "@ant-design/icons";
import "./Navbar.css";

async function handleLogOut() {
  try {
    const resp = await genericDELETEDatabaseCall('/api/auth/logout', {}, 'logout');
    window.location.reload();
  } catch (err) {
    console.log(err);
  }
}

const productsDropdownMenu = {
  items: [
    {
      key: "product1",
      icon: <DollarOutlined style={{ fontSize: 28, color: '#1890ff' }} />, // Financial Builder
      label: <Link to="/fb" style={{ fontSize: 20, fontWeight: 500 }}>Financial Builder</Link>,
    },
    {
      key: "product2",
      icon: <BarChartOutlined style={{ fontSize: 28, color: '#13c2c2' }} />, // Critical Financial Insight
      label: <Link to="/cfi" style={{ fontSize: 20, fontWeight: 500 }}>Critical Financial Insight</Link>,
    },
    {
      key: "product4",
      icon: <BuildOutlined style={{ fontSize: 28, color: '#722ed1' }} />, // Premium Strategic Business Building
      label: <Link to="/psbb" style={{ fontSize: 20, fontWeight: 500 }}>Premium Strategic Business Building</Link>,
    },
  ]
};

const solutionsDropdownMenu = {
  items: [
    {
      key: "solution1",
      icon: <UsergroupAddOutlined style={{ fontSize: 28, color: '#faad14' }} />, // For Teams
      label: <Link to="/solutions/teams" style={{ fontSize: 20, fontWeight: 500 }}>For Teams</Link>,
    },
    {
      key: "solution2",
      icon: <RocketOutlined style={{ fontSize: 28, color: '#eb2f96' }} />, // For Startups
      label: <Link to="/solutions/startups" style={{ fontSize: 20, fontWeight: 500 }}>For Startups</Link>,
    },
    {
      key: "solution3",
      icon: <ApartmentOutlined style={{ fontSize: 28, color: '#52c41a' }} />, // Enterprise
      label: <Link to="/solutions/enterprise" style={{ fontSize: 20, fontWeight: 500 }}>Enterprise</Link>,
    },
  ]
};

function Navbar({ activeKey }) {
  const [productsOpen, setProductsOpen] = useState(false);
  const [solutionsOpen, setSolutionsOpen] = useState(false);
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    const checkAuthStatus = async () => {
      const status = await fetchAuthStatus();
      setIsAuthenticated(status);
    };
    checkAuthStatus();
  }, []);

  return (
    <nav className="navbar">
      <div className="navbar-container navbar-wide">
        <Link to="/">
          <div className="navbar-logo">
            <span>PreNumbers</span>
          </div>
        </Link>
        <Menu
          className="navbar-menu"
          theme="dark"
          mode="horizontal"
          style={{ flex: 1, minWidth: 0, background: "transparent", borderBottom: "none" }}
        >
          <Menu.Item key="products" className="navbar-menu-item navbar-dropdown-parent">
            <Dropdown
              menu={productsDropdownMenu}
              trigger={["hover"]}
              placement="bottom"
              overlayClassName="navbar-tooltip-dropdown"
              arrow
              open={productsOpen}
              onOpenChange={setProductsOpen}
            >
              <span style={{ color: productsOpen ? '#fff' : 'inherit' }}>
                <AppstoreOutlined className="navbar-menu-icon" /> Products {productsOpen ? <UpOutlined className="navbar-down-icon rotate-icon" /> : <DownOutlined className="navbar-down-icon rotate-icon" />}
              </span>
            </Dropdown>
          </Menu.Item>
          <Menu.Item key="solutions" className="navbar-menu-item navbar-dropdown-parent">
            <Dropdown
              menu={solutionsDropdownMenu}
              trigger={["hover"]}
              placement="bottom"
              overlayClassName="navbar-tooltip-dropdown"
              arrow
              open={solutionsOpen}
              onOpenChange={setSolutionsOpen}
            >
              <span style={{ color: solutionsOpen ? '#fff' : 'inherit' }}>
                <SolutionOutlined className="navbar-menu-icon" /> Solutions {solutionsOpen ? <UpOutlined className="navbar-down-icon rotate-icon" /> : <DownOutlined className="navbar-down-icon rotate-icon" />}
              </span>
            </Dropdown>
          </Menu.Item>
          <Menu.Item key="dashboard" icon={<DashboardOutlined className="navbar-menu-icon" />} className={`navbar-menu-item ${activeKey === 'dashboard' ? 'navbar-menu-item-active' : ''}`}>
            <Link to="/dashboard">Dashboard</Link>
          </Menu.Item>
          <Menu.Item key="pricing" icon={<DollarOutlined className="navbar-menu-icon" />} className={`navbar-menu-item ${activeKey === 'pricing' ? 'navbar-menu-item-active' : ''}`}>
            <Link to="/pricing">Pricing</Link>
          </Menu.Item>
          <Menu.Item key="resources" icon={<BookOutlined className="navbar-menu-icon" />} className={`navbar-menu-item ${activeKey === 'resources' ? 'navbar-menu-item-active' : ''}`}>
            <Link to="/resources">Resources</Link>
          </Menu.Item>
        </Menu>
        <div className="navbar-actions">
          <Link to="/contact-sales">
            <Button icon={<PhoneOutlined />} className="navbar-action-btn" type="default">
              <span className="text">Contact Sales</span>
            </Button>
          </Link>
          {isAuthenticated ? (
              <Button onClick={handleLogOut} icon={<UserOutlined />} className="navbar-action-btn" type="default">
                <span className="text">Log out</span>
              </Button>
          ) : (
            <Link to="/login">
              <Button icon={<LoginOutlined />} className="navbar-action-btn" type="default">
                <span className="text">Sign In</span>
              </Button>
            </Link>
          )}
        </div>
      </div>
    </nav>
  );
}

export default Navbar;